import { createFetch, defaultFetchConfig } from '@cbhq/data-layer/network';
import { apiCamelizeMiddleware } from '@cbhq/instant-api-hooks-core/fetch';

// authedFetch needs to be wrapped into a function to avoid window refences in the init.
// Window references in the init will break SSR apps cause window does not exist in the server.
export function getFetchClient() {
  return apiCamelizeMiddleware(
    createFetch({
      ...defaultFetchConfig,
      credentials: 'include',
      setHeaders: {
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          origin: window.location.origin,
        },
      },
      // Disable these since they're not accepted by default for CORS requests
      disableAnalyticsHeaders: true,
    }),
  );
}
